import React from "react";
import { Activity } from "lucide-react";

export default function LoginPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--ink-950)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "var(--ink-900)",
          border: "1px solid var(--slate-border)",
          borderRadius: 16,
          padding: "48px 40px",
          width: 360,
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            marginBottom: 32,
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              background: "var(--acid)",
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Activity size={18} color="var(--ink-950)" strokeWidth={2.5} />
          </div>
          <div style={{ textAlign: "left" }}>
            <div
              style={{
                fontFamily: "Syne, sans-serif",
                fontWeight: 700,
                fontSize: 17,
                color: "#E8EDF3",
                lineHeight: 1.1,
              }}
            >
              CV Parser
            </div>
            <div
              style={{
                fontFamily: "JetBrains Mono, monospace",
                fontSize: 10,
                color: "var(--slate-muted)",
                letterSpacing: "0.08em",
              }}
            >
              be-exec.com
            </div>
          </div>
        </div>

        <div
          style={{
            fontFamily: "DM Sans, sans-serif",
            fontSize: 14,
            color: "var(--slate-muted)",
            marginBottom: 28,
            lineHeight: 1.5,
          }}
        >
          Войдите через корпоративный аккаунт Zoho для доступа к системе
        </div>

        <a
          href="/auth/login"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            width: "100%",
            padding: "12px 20px",
            background: "var(--acid)",
            color: "var(--ink-950)",
            borderRadius: 8,
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 600,
            fontSize: 14,
            textDecoration: "none",
            boxSizing: "border-box",
            transition: "opacity 0.15s ease",
          }}
          onMouseEnter={e => (e.currentTarget.style.opacity = "0.85")}
          onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
        >
          Войти через Zoho
        </a>
      </div>
    </div>
  );
}
